<template>
    <li @click="$emit('select', chat)"
        @contextmenu.prevent="openMenu"
        @mouseenter="isHovered = true"
        @mouseleave="isHovered = false"
        :class="{ 'active': isActive }"
        class="chat-item overflow-hidden" 
        ref="chatItem"
    >
        <div class="chat-item-wrapper d-flex w-100 position-relative"
            :style="{ transform: `translateX(${swipeOffset}px)`, transition: isSwiping ? 'none' : 'transform 0.2s ease-out' }"
            @touchstart="onTouchStart" 
            @touchmove="onTouchMove" 
            @touchend="onTouchEnd"
        >
            <a class="cursor-pointer chat-link flex-shrink-0 w-100" :class="{'pulsing-background':shouldPulsate}">
                <div class="d-flex align-items-start">

                    <div class="me-3 ms-0 align-self-center position-relative">
                        <div class="avatar-wrapper"
                            :class="{
                                'status-online': shouldShowOnlineStatus && chat.isOnline,
                                'status-offline': shouldShowOnlineStatus && !chat.isOnline,
                                'avatar-clickable': !chat.isGroup && !!chat.idContato
                            }"
                            @click="handleAvatarClick">
                            <AvatarField 
                                :foto="displayAvatar" 
                                class="avatar-xs" 
                                style="width: 48px !important; height: 48px !important;" 
                                loading="lazy" 
                            />
                            <span v-if="shouldShowOnlineStatus" 
                                class="status-indicator" 
                                :class="chat.isOnline ? 'online' : 'offline'">
                            </span>
                        </div>
                    </div>

                    <div class="flex-grow-1 overflow-hidden content-area">

                        <div class="d-flex align-items-center mb-1 w-100">
                            <div class="flex-grow-1 overflow-hidden me-2" style="min-width: 0;">
                                <span v-if="chat.nomeClienteAxion" class="mb-1 check_grpro_text d-inline-flex align-items-center text-truncate" style="max-width: 100%;" :title="chat.nomeClienteAxion">
                                    <i class="ri-vip-crown-fill"></i>
                                    <span class="text-truncate">{{ chat.nomeClienteAxion }}</span>
                                </span>
                                <h5 class="text-truncate font-size-15 mb-0 chat-name d-block">
                                    {{ chat.name }}
                                </h5>
                            </div>
                            
                            <div class="flex-shrink-0">
                                <span v-if=showTime class="font-size-11 chat-time text-nowrap"
                                    :class="{ 'text-unread': chat.unreadCount > 0 || chat.isMarkedUnread }">
                                    {{ FormatTime(chat.time) }}
                                </span>
                            </div>
                        </div>

                        <div class="d-flex justify-content-between align-items-center">
                            <p class="chat-user-message text-truncate mb-0" :title="chat.lastMessage.text">

            
                                <span v-if="rotuloLigacao" class="selo-ligacao" :class="{ 'selo-ligacao-tocando': rotuloLigacao.tocando }">
                                    <i :class="rotuloLigacao.icone"></i>
                                    {{ rotuloLigacao.texto }}
                                </span>
                                <span v-else-if="presencaDigitando" class="text-success">
                                    {{ presencaDigitando.texto }}
                                </span>
                                <span v-else-if="chatStore.draftsDict[chat.id] && chatStore.activeChatId !== chat.id">
                                    <span class="text-draft" >Rascunho:</span> {{ chatStore.draftsDict[chat.id] }}
                                </span>
                                <template v-else>
                                    <template v-if="showMessageStatus">
                                        <template v-if="chat.lastMessage.status == 'read'">
                                            <i class="ri-check-double-line me-1" style="color: #50a5f1"></i>
                                        </template>
                                        <!--
                                            Chat interno nunca cai no ✓ único: a mensagem já está
                                            persistida e já foi publicada no NATS pros dois lados, não
                                            existe portadora externa que possa falhar. Só entregue/lido
                                            (de `chats_internos_estados`) têm conteúdo, então o piso é ✓✓.
                                            No WhatsApp o ✓ único continua valendo: enviado ao servidor,
                                            sem confirmação da operadora.
                                        -->
                                        <template v-else-if="chat.lastMessage.status == 'delivered' || chatStoreInterno.isInternalChatMode">
                                            <i class="ri-check-double-line me-1"></i>
                                        </template>
                                        <!-- Recusado pela plataforma (ex.: template Meta sem método de
                                             pagamento). Sem este ramo o card mostrava o check de enviado. -->
                                        <template v-else-if="chat.lastMessage.status == 'error'">
                                            <i class="ri-error-warning-line text-danger me-1" title="Não enviado"></i>
                                        </template>
                                        <template v-else>
                                            <i class="ri-check-line me-1"></i>
                                        </template>
                                    </template>
                                    <strong v-if="getLastMessageSender">
                                        {{ getLastMessageSender }}:
                                    </strong>
                                    <span><i v-if="iconeDoTipo" :class="iconeDoTipo"></i>{{ signaturelessText }}</span>
                                </template>
                                

                            </p>

                            <div class="chat-meta-badges d-flex align-items-center justify-content-end">

                                <span v-if="chat.unreadCount > 0" class="unread-badge me-1">
                                    {{ unreadLabel }}
                                </span>
                                <span v-else-if="chat.isMarkedUnread" class="unread-dot me-1" v-tooltip="'Marcado como não lido'"></span>
                                
                                <!-- Tooltip por slot, não por `v-tooltip`/`html:true`: o nome da
                                     campanha é conteúdo de usuário, e escapar à mão em cada uso é
                                     uma injeção esperando um esquecimento. `--tt-accent` faz a
                                     caixa herdar o âmbar do badge sem uma classe por variante. -->
                                <VTooltip v-if="badgeCampanhaChat" theme="whiz-rich" class="tt-anchor me-1">
                                    <span :class="badgeCampanhaChat.classe">
                                        <i class="ri-megaphone-fill"></i>
                                    </span>

                                    <template #popper>
                                        <div class="tt-card" :style="{ '--tt-accent': badgeCampanhaChat.criado ? 'hsl(28, 92%, 46%)' : 'hsl(28, 92%, 40%)' }">
                                            <div class="tt-title">
                                                <i class="ri-megaphone-fill"></i>
                                                <span class="tt-strong">{{ badgeCampanhaChat.nome ?? 'Campanha' }}</span>
                                            </div>
                                            <div class="tt-body">{{ badgeCampanhaChat.titulo }}</div>
                                            <span class="tt-chip">{{ badgeCampanhaChat.criado ? 'Aberto pela campanha' : 'Tocado pela campanha' }}</span>
                                        </div>
                                    </template>
                                </VTooltip>

                                <template v-if="!chatStore.isTeamMode && !hideTagAtendente">
                                    <template v-if="chat.isBotActive">
                                        <span class="bot-badge" v-tooltip="'Bot ativo'"><i class="ri-settings-fill me-1"></i>BOT</span>
                                    </template>
                                    <template v-else-if="chat.idChatBotIa && !chat.statusIntegracaoIa">
                                        <span class="ia-badge" v-tooltip="'Atendimento com IA'"><i class="ri-shining-2-fill me-1"></i>IA</span>
                                    </template>
                                    <template v-else>
                                        <span v-if="chat.statusIntegracaoIa == 'EM_ATENDIMENTO_HUMANO'" class="ia-badge me-1" v-tooltip="'Atendimento inicial feito com IA'">
                                            <i class="ri-bubble-chart-fill"></i>
                                        </span>
                                        <span v-else-if="chat.statusIntegracaoIa == 'FINALIZADO_POR_IA'" class="ia-badge ia-badge-green me-1" v-tooltip="'Atendimento considerado concluído pela IA'">
                                            <i class="ri-bubble-chart-fill"></i>
                                        </span>
                                        <span 
                                            v-for="atendente of chat.atendentes" :key="atendente.id"
                                            class="attendant-badge" v-tooltip="atendente.name"
                                        >
                                            {{ atendente.initials }}
                                        </span>
                                    </template>
                                </template>

                                <i v-if="chat.isMuted" class="ri-volume-mute-fill text-muted font-size-14 ms-1 chat-icon-status"></i>
                                <Transition name="pin-animation">
                                    <i v-if="chat.isPinned" class="ri-pushpin-fill text-muted font-size-14 ms-1 chat-icon-status"></i>
                                </Transition>


                                <div v-if="!chatStore.isTeamMode && !chatStoreInterno.isInternalChatMode && podeIntervir" class="action-trigger-wrapper">
                                    <VDropdown :distance="6" placement="bottom-end" ref="dropdownRef">
                                            <button type="button" class="btn btn-link p-0 chat-actions-btn" @click.stop="openMenu" title="Mais Ações">
                                                <i class="ri-more-2-fill"></i>
                                            </button>

                                            <template #popper>
                                                <div class="dropdown-menu-v">
                                                    <a v-permission="['conta.inserir_etiquetas']" href="#" class="dropdown-item-v" v-close-popper @click="handleLinkTagClick(chat)">
                                                        <i class="ri-price-tag-3-line me-2"></i> Adicionar etiqueta
                                                    </a>

                                                    <a href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="handleTogglePin(chat)">
                                                        <i :class="chat.isPinned ? 'ri-unpin-line' : 'ri-pushpin-line'" class="me-2"></i>
                                                        {{ chat.isPinned ? 'Desafixar' : 'Fixar' }}
                                                    </a>

                                                    <template v-if="!chat.isGroup">
                                                        <a v-if="chat.unreadCount === 0 && !chat.isMarkedUnread" href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="handleMarkAsUnread(chat)">
                                                            <i class="ri-mail-unread-line me-2"></i> Marcar como não lida
                                                        </a>
                                                        <a v-else href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="handleMarkAsRead(chat)">
                                                            <i class="ri-mail-open-line me-2"></i> Marcar como lida
                                                        </a>

                                                        <div class="dropdown-divider-v"></div>

                                                        <template v-if="(chat.atendentes && chat.atendentes.length > 0) || chat.status != 'Criado'">
                                                            <!-- por favor manter o "transferir atendimento" -->
                                                            <a href="#" class="dropdown-item-v" v-close-popper @click.stop="handleTransferClick(chat)">
                                                                <i class="ri-share-forward-line me-2"></i> Transferir Atendimento
                                                            </a>
                                                            <a v-if="podeMoverQuadro" href="#" class="dropdown-item-v" v-close-popper @click.stop.prevent="abrirMoverQuadroModal()">
                                                                <i class="ri-drag-move-2-line me-2"></i> Mover para Quadro
                                                            </a>
                                                            <a href="#" class="dropdown-item-v text-danger" v-close-popper @click.stop="handleFinishChatClick(chat)">
                                                                <i class="ri-logout-box-r-line me-2"></i> Finalizar Atendimento
                                                            </a>
                                                        </template>

                                                        <template v-else>
                                                            <a href="#" class="dropdown-item-v text-success" v-close-popper @click.stop="handleStartChat(chat)">
                                                                <i class="ri-play-circle-line me-2"></i> Iniciar Atendimento
                                                            </a>
                                                        </template>
                                                    </template>
                                                </div>
                                            </template>
                                    </VDropdown>
                                </div>
                            </div>
                        </div>

                        <div class="d-flex align-items-center flex-wrap gap-1 mt-1 chat-tags-container"
                            v-if="(chat.tags && chat.tags.length > 0) || chat.isFavorite">

                            <Transition name="star-animation">
                                <i v-if="chat.isFavorite" class="ri-star-fill font-size-14 chat-star-icon me-1" title="Favorito"></i>
                            </Transition>

                            <template v-for="tag in chat.tags" :key="tag.nome">
                                <div class="tag-clean-pill"
                                    :style="{
                                        '--tag-color': tag.cor,
                                        backgroundColor: tag.cor + '0D'
                                    }">
                                    <span class="tag-dot-solid" :style="{ backgroundColor: tag.cor }"></span>
                                    <span class="tag-name">{{ tag.nome }}</span>
                                </div>
                            </template>
                        </div>

                    </div>
                </div>

                <div class="corner-badges-wrapper">
                    
                    <div v-if="nomeCanal" class="channel-corner-badge" v-tooltip="'Canal: ' + nomeCanal">
                        # {{ nomeCanal }}
                    </div>

                    <div v-if="chatStore.initialized && !chatStore.isTeamMode && !chatStoreInterno.isInternalChatMode"
                        class="instance-corner-badge position-relative" 
                        :style="{ backgroundColor: cornerBadgeBg }" 
                        v-tooltip="nomeInbox">
                        {{ nomeInbox }}
                    </div>
                </div>

            </a>

            <div class="swipe-actions d-lg-none position-absolute top-0 d-flex align-items-center justify-content-end h-100 pe-2"
                :style="{ right: '-140px', width: '140px' }">

                <template v-if="!chat.isGroup">
                    <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop="handleLinkTagClick(chat); swipeOffset = 0"><i class="ri-price-tag-3-line text-primary"></i></button>
                    <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop.prevent="handleTogglePin(chat); swipeOffset = 0"><i :class="chat.isPinned ? 'ri-unpin-line' : 'ri-pushpin-line'" class="text-warning"></i></button>
                    <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop="handleFinishChatClick(chat); swipeOffset = 0"><i class="ri-check-line text-success"></i></button>
                </template>

                <template v-else>
                    <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop="handleLinkTagClick(chat); swipeOffset = 0"><i class="ri-price-tag-3-line text-primary"></i></button>
                    <button class="btn btn-sm btn-light rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop.prevent="handleTogglePin(chat); swipeOffset = 0"><i :class="chat.isPinned ? 'ri-unpin-line' : 'ri-pushpin-line'" class="text-warning"></i></button>
                    <button class="btn btn-sm btn-danger rounded-circle shadow-sm mx-1 flex-shrink-0 d-flex align-items-center justify-content-center" @click.stop="swipeOffset = 0"><i class="ri-delete-bin-line"></i></button>
                </template>

            </div>
        </div>

        <MoverQuadroModal
            :is-open="showMoverQuadroModal"
            :quadros="quadrosDisponiveis"
            :current-quadro-id="chat.idQuadro ?? null"
            :current-quadro-nome="currentQuadroNome"
            :saving="movingQuadro"
            @close="showMoverQuadroModal = false"
            @confirm="moverParaQuadro"
        />
    </li>
</template>

<script setup lang="ts">
import { ref, computed } from 'vue';
import { rotuloPresenca, useChatStore } from '@/stores/app/chatStore';
import { branding } from '@/config/branding';
import AvatarField from '@/components/global/AvatarField.vue';
import { useUiStore } from '@/stores/app/uiStore';
import { vClosePopper, hideAllPoppers } from 'floating-vue';
import { PropType } from 'vue';
import { Chat } from '@/mocks/app/mockChatData';
import { Dropdown } from 'bootstrap';
import { FormatTime, pastelColorFromString } from '@/stores/app/chatUtils';
import { PromptToFinalizarAtendimento } from '../../swal/FinalizarAtendimento';
import { rotuloPresencaChatInterno, useInternalChatStore } from '../../../../stores/app/chatInternoStore';
import { ResponseEtiqueta } from '@/services/etiquetas/etiquetas.service';
import { useTagStore } from '@/stores/app/tagStore';
import { getIconClassFromType } from '@/services/mensagens/mensagens.service';
import { TextContentUtil } from '../../../../stores/app/chatUtils';
import { useAuthStoreUser } from '@/stores/app/authUser';
import { formatUnreadCount } from '@/utils/formatUnreadCount';
import { useContatoStore } from '@/stores/app/contatoStore';
import { badgeCampanha } from '@/utils/campanhaAtendimento';
import { useCampanhasStore } from '@/stores/app/campanhas';
import { toast } from 'vue3-toastify';
import Swal from 'sweetalert2';
import MoverQuadroModal from '@/components/app/modals/MoverQuadroModal.vue';
import { useMoverQuadro } from '@/composables/useMoverQuadro';
import { useLigacoesStore } from '@/stores/app/ligacoesStore';
import { reagirAoResultadoDaFoto } from '@/utils/fotoDeContato';
FormatTime;

const emit = defineEmits<{tags: [value: ResponseEtiqueta[]], select: [value: Chat]}>();
const props = defineProps({
    hideTagAtendente: { type: Boolean, default: false },
    forcePulsateState: { type: [Boolean, null], default: null },
    chat: {
        type: Object as PropType<Chat>,
        required: true
    },
    showTime: {
        type: Boolean,
        default: true
    }
});

const authUser = useAuthStoreUser();
const contatoStore = useContatoStore();
const chatStoreNormal = useChatStore();
const campanhasStore = useCampanhasStore();
const uiStore = useUiStore();
const chatStoreInterno = useInternalChatStore();
const ligacoesStore = useLigacoesStore();

const chatStore = computed(() =>
    chatStoreInterno.isInternalChatMode
        ? chatStoreInterno
        : chatStoreNormal
);

// Feature "Mover para Quadro" para este card (mesma lógica/regra do ChatHeader).
const {
    showModal: showMoverQuadroModal,
    moving: movingQuadro,
    quadrosDisponiveis,
    podeMover: podeMoverQuadro,
    currentQuadroNome,
    ensureQuadrosLoaded: ensureQuadrosMoverLoaded,
    abrirModal: abrirMoverQuadroModal,
    moverParaQuadro,
} = useMoverQuadro(() => props.chat);

const tagStore  = useTagStore();

const shouldShowOnlineStatus = computed(() => 
    chatStoreInterno.isInternalChatMode
); 

const signaturelessText = computed(() => TextContentUtil.extractNonSignature(props.chat?.lastMessage?.text) ?? '');
// Texto da prévia vai por `{{ }}`, nunca `v-html`: é conteúdo do contato.
const iconeDoTipo = computed(() => getIconClassFromType(props.chat.lastMessage?.ogType));

const isActive = computed(() =>
    chatStore.value.activeChatId === props.chat.id
);

const nomeCanal = computed(() => {
    const chatDinamico = props.chat as any; 
    
    if (chatDinamico.nomeCanal) return chatDinamico.nomeCanal;
    
    if (chatDinamico.canal && chatDinamico.canal.nome) return chatDinamico.canal.nome;
    
    return null;
});

/**
 * Menu de acoes do card. Atendimento conduzido pelo Agente de IA exige
 * `inbox.intervir_atendimentos_agente` NO INBOX DESTE chat; atendimento comum
 * segue liberado para todo mundo, como sempre foi.
 */
const podeIntervir = computed(() => chatStoreNormal.podeIntervirNoAtendimentoDoAgente(props.chat as Chat));

const nomeInbox = computed(() => chatStoreNormal.initialized && props.chat?.idInbox ? chatStoreNormal.inboxMap.get(props.chat.idInbox)?.nome : '');
const cornerBadgeBg = computed(() => props.chat?.idInbox ? pastelColorFromString(props.chat.idInbox) : '#fff');

// Substitui a linha de prévia enquanto alguém digita, no mesmo lugar do "Rascunho:".
// Vale para os dois modos, com fontes diferentes: WhatsApp resolve pelo chat inteiro
// (grupo pode ter vários digitando, com nome e cor); chat interno é 1:1 e o sinal
// chega por `idChat`, então basta o texto.
const presencaDigitando = computed(() => {
    if (chatStoreInterno.isInternalChatMode) {
        const texto = rotuloPresencaChatInterno(props.chat?.id);
        return texto ? { texto } : null;
    }
    return rotuloPresenca(props.chat, chatStoreNormal.contatosByCodigo);
});

/**
 * Selo de ligação em curso, na mesma linha da prévia — e ACIMA do "digitando":
 * quem está no telefone com o contato precisa ver isso antes de qualquer coisa.
 *
 * Só WhatsApp: grupo não recebe ligação, e o chat interno não tem ligação
 * nenhuma. A fonte é o store da ligação (evento ao vivo `LIGACAO_ATUALIZADA`),
 * não o atendimento — o servidor não persiste "está tocando agora".
 */
const ligacaoEmCurso = computed(() => {
    if (chatStoreInterno.isInternalChatMode || props.chat?.isGroup) return null;
    return ligacoesStore.vivasPorAtendimento[props.chat.id as string] ?? null;
});

const rotuloLigacao = computed(() => {
    const ligacao = ligacaoEmCurso.value;
    if (!ligacao) return null;

    if (ligacao.situacao === 'ATENDIDA') {
        return { texto: 'Em ligação', icone: 'ri-phone-fill', tocando: false };
    }
    // TOCANDO: o lado que originou muda a frase — "Chamando…" é a nossa
    // discagem esperando o outro atender.
    return ligacao.direcao === 'REALIZADA'
        ? { texto: 'Chamando…', icone: 'ri-phone-line', tocando: true }
        : { texto: 'Ligação recebida', icone: 'ri-phone-line', tocando: true };
});

const shouldPulsate = computed(() => props.forcePulsateState == null ? props.chat.status == 'Criado' : props.forcePulsateState);

/** Badge de campanha (criada por / tocado por). Grupos nunca recebem. */
/**
 * Nome da campanha resolvido pelo store, e não pelo payload: o bloco `disparo` do
 * atendimento não traz o nome, e pedi-lo ao servidor custaria um join na listagem
 * de atendimentos, que é a consulta mais quente do sistema.
 *
 * A carga do store é do `ListHeader` (watch `immediate` na conta), que está sempre
 * montado junto com a lista — buscar aqui multiplicaria a chamada por card. Sendo
 * reativo, a campanha que chegar depois do primeiro render preenche o nome sozinha;
 * até lá o tooltip mostra só "Campanha", nunca `undefined`.
 */
const nomeCampanhaDoChat = computed(() => {
    const id = props.chat.disparo?.idDisparo;
    if (!id) return null;
    return campanhasStore.campanhas.find(c => c.id === id)?.nome ?? null;
});

const badgeCampanhaChat = computed(() => badgeCampanha(props.chat, nomeCampanhaDoChat.value));

/** Badge de não lidas: acima de 99 vira "99+" para não esticar a pílula. */
const unreadLabel = computed(() => formatUnreadCount(props.chat.unreadCount));

// LÓGICA DE SIMULAÇÃO DE AVATAR / quando backend tiver pronto só apagar isso
const displayAvatar = computed(() => {
    if (props.chat.avatar && props.chat.avatar.length > 5) {
        return props.chat.avatar;
    }

    return branding.images.avatarFallback;
});

const dropdownRef = ref<null|InstanceType<typeof Dropdown>>(null);
const isHovered = ref(false); 
const swipeOffset = ref(0);
const isSwiping = ref(false);
let startX = 0;
let startY = 0;
let isVerticalScroll = false;

function onTouchStart(e: TouchEvent) {
    if (window.innerWidth >= 992) return; // Evita conflito no desktop
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwiping.value = true;
    isVerticalScroll = false;
}

function onTouchMove(e: TouchEvent) {
    if (!isSwiping.value || isVerticalScroll || window.innerWidth >= 992) return;
    
    const currentX = e.touches[0].clientX;
    const currentY = e.touches[0].clientY;
    const diffX = currentX - startX;
    const diffY = currentY - startY;

    // Se estiver fazendo scroll vertical na lista, cancela o swipe lateral
    if (Math.abs(diffY) > Math.abs(diffX) && Math.abs(diffY) > 10) {
        isVerticalScroll = true;
        return;
    }

    if (diffX < 0) {
        // Arrasta para a esquerda (limita de acordo com a quantidade de botões)
        e.preventDefault(); 
        const maxSwipe = -140;
        swipeOffset.value = Math.max(diffX, maxSwipe);
    } else if (diffX > 0 && swipeOffset.value < 0) {
        // Permite empurrar de volta para a direita se estiver aberto
        swipeOffset.value = Math.min(0, -140 + diffX);
    }
}

function onTouchEnd() {
    if (!isSwiping.value || window.innerWidth >= 992) return;
    isSwiping.value = false;
    
    // Snap magnético (abre totalmente ou fecha dependendo do esforço)
    const threshold = -50;
    const maxSwipe  = -140;
    
    if (swipeOffset.value < threshold) {
        swipeOffset.value = maxSwipe; 
    } else {
        swipeOffset.value = 0; 
    }
}

function openMenu() {
    // O botao direito abre este mesmo menu. Sem a guarda, o menu do card de um
    // atendimento conduzido pela IA seguiria acessivel por contextmenu mesmo com
    // o gatilho de tres pontinhos fora do DOM.
    if (!podeIntervir.value) return;
    hideAllPoppers();
    // Pré-carrega os quadros para o item "Mover para Quadro" já aparecer no 1º open.
    ensureQuadrosMoverLoaded();
    if (dropdownRef.value) dropdownRef.value.show();
}

function handleStartChat(chat: Chat) {
    chatStoreNormal.selectChat(chat.id);
}

function handleLinkTagClick(chat: Chat) {
    chatStoreNormal.setChatToLinkTags(chat); 
    uiStore.openLinkTagModal();      
}

function handleToggleMute(chat: Chat) {
    chatStoreNormal.toggleMute(chat.id);
}

async function handleTogglePin(chat: Chat) {
    await chatStoreNormal.togglePin(chat.id);
}

async function handleMarkAsUnread(chat: Chat) {
    await chatStoreNormal.markAsUnread(chat.id);
}

async function handleMarkAsRead(chat: Chat) {
    await chatStoreNormal.resolveMarkChatAsRead(chat.id, chat.isGroup);
}

function handleToggleFavorite (chat: Chat) {
    chatStoreNormal.toggleFavorite(chat.id);
}

function handleTransferClick(chat: Chat) {
    chatStoreNormal.selectChat(chat.id);
    uiStore.openTransferModal();
}

function handleFinishChatClick (chat: Chat) {
    PromptToFinalizarAtendimento(chat, chatStoreNormal);
}

async function handleAvatarClick(e: MouseEvent) {
    if (props.chat.isGroup || !props.chat.idContato) return;

    e.stopPropagation();

    const result = await Swal.fire({
        title: 'Foto do contato',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonText: 'Buscar no WhatsApp',
        denyButtonText: 'Abrir chat',
        cancelButtonText: 'Fechar',
        confirmButtonColor: '#25d366',
        html: '<span style="font-size:13px;color:#6c757d;">⚠️ Buscar a foto do WhatsApp pode resultar no <strong>banimento do número</strong>. Use com responsabilidade.</span>',
    });

    if (result.isConfirmed) {
        const idConta = authUser.currentConta?.id;
        if (!idConta) return toast.error('Conta não identificada.');
        try {
            const resultado = await contatoStore.buscarFotoPerfil(props.chat.idContato, props.chat.codigoContato, idConta);
            await reagirAoResultadoDaFoto(resultado);
        } catch (err) {
            toast.error((err as Error).message || 'Erro ao buscar foto.');
        }
    } else if (result.isDenied) {
        emit('select', props.chat);
    }
}

const getLastMessageSender = computed(() => 
    chatStoreInterno.isInternalChatMode 
        ? null 
        : (!props.chat.isGroup && !props.chat.lastMessage.isFromMe) || (props.chat.lastMessage.sender == authUser?.user?.nome || props.chat.lastMessage.sender == 'Você')
            ? null : props.chat.lastMessage?.sender)

// Ack da prévia: vale para WhatsApp E chat interno — o que decide é a última
// mensagem ser minha. O chat interno preenche `isFromMe`/`status` no
// chatInternoStore a partir de `chats_internos_estados`.
// Prévia de LIGAÇÃO nunca leva check: nada foi enviado, entregue ou lido — a
// ligação que NÓS fizemos é `isFromMe`, mas um ✓ ali diria uma coisa falsa.
const showMessageStatus = computed(() =>
    !!props.chat.lastMessage?.isFromMe && props.chat.lastMessage?.ogType !== 'LIGACAO')

</script>

<style scoped>
.chat-item {
    margin-bottom: 2px;
}

.chat-link {
    position: relative;
    display: block;
    padding: 12px 10px;
    padding-bottom: 16px;
    border-radius: 12px;
    text-decoration: none !important;
    transition: background-color 0.2s ease;
    overflow: hidden;
    border: 1px solid transparent;
}

.chat-item:hover .chat-link {
    background-color: var(--bs-light);
}
.chat-item.active .chat-link {
    background-color: var(--bs-primary-bg-subtle);
}

.instance-corner-badge {
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 8px;
    font-weight: 800;
    color: #fff;
    padding: 3px 12px 3px 14px;
    border-top-left-radius: 12px;
    border-bottom-right-radius: 12px;
    z-index: 5;
    box-shadow: -2px -2px 6px rgba(0,0,0,0.06);
    line-height: 1.1;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    cursor: help; 
    pointer-events: auto; 
}

.chat-tags-container {
    padding-right: 75px;
    min-height: 22px;
}

.tag-clean-pill {
    display: inline-flex;
    align-items: center;
    padding: 3px 8px 3px 5px;
    border-radius: 6px;
    font-size: 10.5px;
    font-weight: 600;

    background-color: var(--tag-bg, rgba(0,0,0,0.03));
    border: 1px solid transparent;

    transition: all 0.2s ease;
    cursor: default;
    max-width: 140px;
}

.tag-dot-solid {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    margin-right: 6px;
    flex-shrink: 0;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,0.1);
}

.tag-name {
    color: var(--bs-gray-700);
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.2;
}

.chat-item:hover .tag-clean-pill {
    transform: translateY(-1px);
    background-color: #fff;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
}

.action-trigger-wrapper {
    width: 0;
    opacity: 0;
    overflow: hidden;
    transition: width 0.25s cubic-bezier(0.175, 0.885, 0.32, 1.275),
                opacity 0.2s ease;
    display: flex;
    justify-content: center;
}

.chat-item:hover .action-trigger-wrapper,
.chat-item.active .action-trigger-wrapper {
    width: 24px;
    opacity: 1;
    margin-left: 4px;
}

.chat-actions-btn {
    color: var(--bs-gray-500);
    font-size: 18px;
    white-space: nowrap;
    text-decoration: none !important;
    border: none;
    display: flex;
}
.chat-actions-btn:hover { color: var(--bs-primary); }

.chat-name { font-weight: 600; color: var(--bs-gray-900); }
.chat-time { color: var(--bs-gray-500); font-weight: 500; }
.chat-user-message { color: var(--bs-gray-600); font-size: 13.5px; }
.text-sender { color: var(--bs-gray-800); font-weight: 600; }

/* `min-width` igual à `height` deixa 1 dígito num círculo exato; o padding
   lateral e o raio absoluto fazem a badge virar pílula ao crescer para "99+",
   em vez de esticar o círculo numa elipse. */
.unread-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 18px;
    height: 18px;
    padding: 0 6px;
    border-radius: 9999px;
    background-color: var(--bs-success);
    color: #fff;
    font-size: 10px;
    line-height: 1;
    font-weight: 700;
    white-space: nowrap;
    font-variant-numeric: tabular-nums;
    animation: pulse-green 1.5s infinite;
}

/* marcação manual "não lido": dot sem número (estilo WhatsApp) */
.unread-dot {
    display: inline-block;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background-color: var(--bs-success);
    animation: pulse-green 1.5s infinite;
}

.attendant-badge {
    background-color: #8d8d8d80;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 10px;
    text-transform: uppercase;
    white-space: nowrap;
    transition: transform 0.25s ease;
}

.bot-badge {
    background-color: #50a5f1;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 10px;
    text-transform: uppercase;
    white-space: nowrap;
    transition: transform 0.25s ease;
}

.ia-badge {
    background-color: #d947ef;
    color: #fff;
    font-size: 10px;
    font-weight: 700;
    padding: 2px 6px;
    border-radius: 10px;
    text-transform: uppercase;
    white-space: nowrap;
    transition: transform 0.25s ease;
}

.ia-badge.ia-badge-green {
    background-color: hsl(147, 95%, 43%);
}

/* Campanha: mesma família visual dos badges de bot/IA. Criado = cheio (a campanha
   trouxe este atendimento do nada); tocado = contornado (ele já existia). */
/* Só o ícone: a palavra CAMPANHA repetia o que o megafone já diz e disputava
   largura com o nome do contato na linha. O nome da campanha e o que ela fez com
   este atendimento continuam no tooltip, que é onde cabem por extenso.
   Quadrado e centrado em vez da pílula de texto — sem rótulo, o padding
   horizontal deixava o selo torto. */
.campanha-badge {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    font-size: 11px;
    line-height: 1;
    border-radius: 50%;
    flex-shrink: 0;
    transition: transform 0.25s ease;
}

.campanha-badge.campanha-badge-criado {
    background-color: hsl(28, 92%, 52%);
    color: #fff;
}

.campanha-badge.campanha-badge-tocado {
    background-color: transparent;
    color: hsl(28, 92%, 42%);
    border: 1px solid hsl(28, 92%, 52%);
}

[data-bs-theme=dark] .campanha-badge.campanha-badge-tocado {
    color: hsl(28, 92%, 62%);
}

.chat-icon-status { transition: color 0.2s; }


[data-bs-theme=dark] .chat-name { color: #f8f9fa; }
[data-bs-theme=dark] .text-sender { color: #dee2e6; }
[data-bs-theme=dark] .chat-user-message { color: #adb5bd; }
[data-bs-theme=dark] .chat-time { color: #6c757d; }

[data-bs-theme=dark] .chat-item:hover .chat-link {
    background-color: rgba(255,255,255,0.03);
}
[data-bs-theme=dark] .chat-item.active .chat-link {
    background-color: rgba(var(--bs-primary-rgb), 0.15);
}

[data-bs-theme=dark] .tag-clean-pill {
    background-color: rgba(255,255,255,0.04) !important;
    border-color: rgba(255,255,255,0.08) !important;
}
[data-bs-theme=dark] .tag-name {
    color: #ced4da;
}
[data-bs-theme=dark] .chat-item:hover .tag-clean-pill {
    background-color: rgba(255,255,255,0.08) !important;
    box-shadow: none;
}
[data-bs-theme=dark] .tag-dot-solid {
    box-shadow: none;
    filter: brightness(1.2);
}

[data-bs-theme=dark] .instance-corner-badge {
    box-shadow: -2px -2px 8px rgba(0,0,0,0.5);
}

.avatar-wrapper { border-radius: 50%; padding: 2px; border: 2px solid transparent; display: inline-block; }
.avatar-clickable { cursor: pointer; transition: border-color 0.2s; }
.avatar-clickable:hover { border-color: #25d366; }

.status-indicator {
    position: absolute;
    bottom: 3px;
    right: 5px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    border: 2px solid var(--bs-sidebar-bg); /* Cria um recorte visual entre a bolinha e a foto */
    z-index: 1;
}

.status-indicator.online {
    background-color: var(--bs-success);
}

.status-indicator.offline {
    background-color: #adb5bd5c;
}

.star-animation-enter-active { animation: star-pop 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275); }
@keyframes star-pop { 0% { transform: scale(0); } 100% { transform: scale(1); } }

@keyframes softPulseRed {
    0% {
        box-shadow: inset 0 0 0 100vmax rgba(255, 100, 100, 0);
    }
    50% {
        box-shadow: inset 0 0 0 100vmax rgba(255, 100, 100, 0.16);
    }
    100% {
        box-shadow: inset 0 0 0 100vmax rgba(255, 100, 100, 0);
    }
}

.pulsing-background {
    animation: softPulseRed 1.3s ease-in-out infinite;
}

.text-unread {
    color: var(--bs-success) !important;
    font-weight: 600;
}

.text-draft {
    color: var(--bs-success) !important;
    font-weight: 600;
}

/* Selo de ligação em curso. Verde do Bootstrap (mesma família do "digitando" e
   do contador de não lidas) e não uma cor própria: o card já tem vermelho para
   urgência e âmbar para campanha. `--bs-*` porque o tema troca por
   `data-bs-theme` no body — cor fixa aqui ficaria ilegível no escuro. */
.selo-ligacao {
    color: var(--bs-success);
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 4px;
}

/* Enquanto toca, o selo pisca; atendida fica estável. É a única pista de que a
   coisa está acontecendo AGORA num card que o operador vê de relance. */
.selo-ligacao-tocando {
    animation: piscaSeloLigacao 1.2s ease-in-out infinite;
}

@keyframes piscaSeloLigacao {
    0%   { opacity: 1; }
    50%  { opacity: 0.45; }
    100% { opacity: 1; }
}

/* Acessibilidade: quem pediu menos movimento no SO recebe o selo parado, com a
   informação intacta. */
@media (prefers-reduced-motion: reduce) {
    .selo-ligacao-tocando { animation: none; }
}

/* Adicione no bloco <style scoped> */

.corner-badges-wrapper {
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    z-index: 5;
    pointer-events: none; /* Permite clicar no chat através da área vazia */
}

.channel-corner-badge {
    background-color: #50a5f140;
    color: #50a5f1;          /* Cor do texto (azul similar ao protótipo) */
    font-size: 9px;
    font-weight: 700;
    padding: 3px 8px;
    border-top-left-radius: 8px;
    border-top-right-radius: 0px; /* Borda arredondada visual */
    margin-right: -10px;       /* Um leve overlap para ficar "atrás" ou colado na badge da inbox */
    margin-bottom: 0px;
    padding-right: 15px;      /* Espaço extra na direita para compensar o overlap */
    z-index: 4;               /* Fica atrás da badge da inbox */
    text-transform: uppercase;
    letter-spacing: 0.3px;
    pointer-events: auto;
    line-height: 1.1;
    
    max-width: 90px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ATUALIZAÇÃO na classe existente .instance-corner-badge */
.instance-corner-badge {
    /* As propriedades position, bottom e right originais podem ser removidas ou sobrescritas 
       pela classe .position-relative do bootstrap usada no template, ou forçadas aqui: */
    position: relative !important;
    bottom: auto !important;
    right: auto !important;
    
    /* Manter o restante do estilo original */
    font-size: 8px;
    font-weight: 800;
    color: #fff;
    padding: 3px 12px 3px 14px;
    border-top-left-radius: 12px;
    border-bottom-right-radius: 12px;
    z-index: 5;
    box-shadow: -1px 1px 2px 0px rgb(0 0 0 / 24%);
    line-height: 1.1;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    
    max-width: 100px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    
    cursor: help; 
    pointer-events: auto; 
}

/* Fundo forçado no chat link para não deixar os botões vazarem no modo arrasto */
.chat-link {
    background-color: var(--bs-body-bg); 
}
[data-bs-theme=dark] .chat-link {
    background-color: transparent; /* No modo dark a cor herda de forma diferente, mas mantenha compatível */
}

/* Oculta os botões padrão de hover do desktop no celular (Dropdown de "Mais Ações") */
@media (max-width: 991.98px) {
    .action-trigger-wrapper {
        display: none !important;
    }
    .chat-link {
        /* Garante cor sólida acima das actions no mobile */
        background-color: var(--bs-body-bg);
    }
    [data-bs-theme=dark] .chat-link {
        background-color: var(--bs-sidebar-sub-bg);
    }
}
</style>